
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import {
    DialogBase,
    DialogContainerBase,
    ParameterList
} from '../../core';

const GeneratePolygonDialog = ({
    generatePolygonParams,
    open,
    onDismiss
}) => {

    const VALUE_GENERATE = 1;
    const VALUE_CLOSE = 0;

    const [values, setValues] = React.useState({});

    const handleConfirm = () => {
        handleDismiss(VALUE_GENERATE);
    }

    const handleChangeValue = (paramId, value) => {
        setValues(values_ => {
            return {
                ...values_,
                [paramId]: value
            };
        });
    }

    const handleDismiss = (resultValue) => {
        if (onDismiss) {
            let res = {button: resultValue};
            if (resultValue === 1) {
                res.values = values;
            }
            onDismiss(res);
        }
    }

    return (
        <DialogBase
            buttons={[
                {primary: true, title: 'Generovat', value: VALUE_GENERATE},
                {primary: false, title: 'Zrušit', value: VALUE_CLOSE}
            ]}
            minWidth={500}
            open={open}
            onDismiss={handleDismiss}
            title="Generování polygonu"
        >
            <Stack>
                <ParameterList
                    params={generatePolygonParams}
                    paramValues={values}
                    onConfirm={handleConfirm}
                    onChangeValue={handleChangeValue}
                />
            </Stack>
        </DialogBase>
    );
}

class GeneratePolygonDialogContainer extends DialogContainerBase {
    static resolve = null;
    static instance = null;

    static create() {
        GeneratePolygonDialogContainer.instance = DialogContainerBase.create(
            GeneratePolygonDialogContainer.instance,
            GeneratePolygonDialogContainer
        );
        return GeneratePolygonDialogContainer.instance;
    }

    constructor(props) {
        super(props, {
            generatePolygonParams: null
        });
    }

    getResolve() {
        return GeneratePolygonDialogContainer.resolve;
    }

    open(generatePolygonParams) {
        return super.open({
            generatePolygonParams
        });
    }

    renderContent() {
        let props = {
            generatePolygonParams: this.state.generatePolygonParams,
            ...this.getDialogProps()
        }
        return (
            <GeneratePolygonDialog
                {...props}
            />
        );
    }

    setResolve(res) {
        GeneratePolygonDialogContainer.resolve = res;
    }
}

export default GeneratePolygonDialogContainer.create;
